module.exports = __webpack_public_path__ + "img/control_de_calidad_16-9_960.e7af96e3.webp";